import { render, staticRenderFns } from "./distribution.vue?vue&type=template&id=54cf5358&scoped=true&"
import script from "./distribution.vue?vue&type=script&lang=ts&"
export * from "./distribution.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54cf5358",
  null
  
)

export default component.exports